import { ArrowDownIcon, ArrowUpIcon } from "@heroicons/react/24/outline";
import { tableUtils } from "./tableUtils";
import type { TableColumn, TableRow } from "./models";

export const columnRenderers = {
  movementPercentage(col: TableColumn, row: TableRow, value: any) {
    const percentage = `${Math.floor(value * 100)
      .toString()
      .padStart(2, "0")}%`;
    const arrow = (() => {
      const direction = tableUtils.getCell(col, row)?.direction;
      if (direction === 1)
        return <ArrowUpIcon className="inline h-3 text-green-600" />;
      if (direction === -1)
        return <ArrowDownIcon className="inline h-3 text-red-600" />;
      return <span className="pl-3" />;
    })();
    return (
      <span>
        <span>
          {arrow}
          {percentage}
        </span>
      </span>
    );
  },
};
